import type { TFunction } from '@jq4race/i18n';

/** Groups under `enums.*` in the `common` namespace. */
export type EnumGroup =
  | 'niche'
  | 'visitorType'
  | 'paymentMethod'
  | 'invoiceStatus'
  | 'invoiceLineKind'
  | 'orgStatus'
  | 'photoAngle'
  | 'smsStatus'
  | 'subscriptionStatus'
  | 'membershipStatus'
  | 'userRole';

/**
 * Human label for a raw backend enum value (e.g. payment method `cash`,
 * visitor type `guest`, niche `country_club`). Works with a `t` bound to any
 * namespace because it addresses the `common` namespace explicitly. Unknown
 * values fall back to the raw value so a new backend enum never renders blank.
 */
export function enumLabel(
  t: TFunction,
  group: EnumGroup,
  value: string | null | undefined,
): string {
  if (value === null || value === undefined || value === '') return '—';
  return t(`common:enums.${group}.${value}`, { defaultValue: value });
}
